import { render } from "./UiCheckbox.vue?vue&type=template&id=f782200c&scoped=true&lang=pug"
import script from "./UiCheckbox.vue?vue&type=script&lang=js"
export * from "./UiCheckbox.vue?vue&type=script&lang=js"

import "./UiCheckbox.vue?vue&type=style&index=0&id=f782200c&lang=sass&scoped=true"

import exportComponent from "D:\\Front\\project\\valeriya.artist\\valeriya.artist.admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f782200c"]])

export default __exports__